import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import ShimmerLoader from "../../pages/ShimmerLoader/ShimmerLoader";
import NoDataFound from "../common/NoDataFound";
import Styles from "./Rewards.module.css";
import currenyFormat from "../common/currentFormat";
// import { useDispatch, useSelector } from "react-redux";
// import { getAllTransactionAction } from "../../../store/actions/transaction/TransactionActions";

const Rewards = ({ transactions, loading }) => {
  // const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleRowClick = (transaction_id) => {
    navigate(`/transactions-details/${transaction_id}`);
  };

  return (
    <>
      <div className='card-body'>
        <div className='table-responsive ticket-table'>
          <div id='ticket_wrapper' className='dataTables_wrapper no-footer'>
            <div className='table-responsive'>
              {/* <table id='example' className='display dataTablesCard table-responsive-xl dataTable no-footer w-100'>
                <thead>
                  <tr>
                    <th>Transaction ID</th>
                    <th>Name</th>
                    <th>Phone Number</th>
                    <th>Receiver Name</th>
                    <th>Status</th>
                    <th>Gold Quantity</th>
                    <th>Price per gram</th>
                    <th>Total Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.length > 0 ? (
                    transactions.map((item, index) => (
                      <tr key={index} onClick={() => handleRowClick(item.transaction_id)} style={{ cursor: "pointer" }}>
                        <td>
                          <Link to={`/transactions-details/${item.transaction_id}`}>{item.transaction_id ? item.transaction_id : "--"}</Link>
                        </td>
                        <td>
                          {" "}
                          <Link to={`/transactions-details/${item.transaction_id}`}>{item.customer_name ? item.customer_name : "--"}</Link>
                        </td>
                        <td>
                          <Link to={`/transactions-details/${item.transaction_id}`}>{item.customer_phone ? item.customer_phone : "--"}</Link>
                        </td>

                        <td>
                          <Link to={`/transactions-details/${item.transaction_id}`}>{item.receiver_name ? item.receiver_name : "--"}</Link>
                        </td>
                        <td>
                          <Link to={`/transactions-details/${item.transaction_id}`}>
                            <span className='text-capitalize'>{item.status ? item.status : "--"}</span>
                          </Link>
                        </td>
                        <td>
                          <Link to={`/transactions-details/${item.transaction_id}`}>{item.gold_quantity ? `${item.gold_quantity} gm` : "--"} gm</Link>
                        </td>
                        <td>
                          <Link to={`/transactions-details/${item.transaction_id}`}> ₹ {item.price_per_gram ? item.price_per_gram : "--"}</Link>
                        </td>
                        <td>
                          <Link to={`/transactions-details/${item.transaction_id}`}> ₹ {item.total_amount ? item.total_amount : "--"}</Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className={`${Styles.no_hover}`}>
                      <td className={`fs-3 text-center`} colSpan={9}>
                        <NoDataFound width={500} />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table> */}
              <table id='example' className='display dataTablesCard table-responsive-xl dataTable no-footer w-100'>
                <thead>
                  <tr>
                    <th>Transaction ID</th>
                    <th>Name</th>
                    <th>Phone Number</th>
                    {/* <th>Receiver Name</th> */}
                    <th className="text-center">Status</th>
                    <th className="text-center">Gold Quantity</th>
                    <th className="text-center">Price per gram</th>
                    <th className="text-center">Total Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={8} className='text-center'>
                        <ShimmerLoader width='95%' height='20%' count={3} />
                      </td>
                    </tr>
                  ) : transactions.length > 0 ? (
                    transactions.map((item, index) => (
                      <tr key={index}>
                        <td onClick={() => handleRowClick(item.transaction_id)} style={{ cursor: "pointer" }}>
                          <Link className={`${Styles.link}`} to={`/transactions-details/${item.transaction_id}`}>{item.transaction_id || "--"}</Link>
                        </td>
                        <td>
                          {item.customer_name || "--"}
                        </td>
                        <td>
                          {item.customer_phone || "--"}
                        </td>
                        {/* <td>
                          {item.receiver_name || "--"}
                        </td> */}
                        <td className="text-center">
                            <span className='text-capitalize'>{item.status || "--"}</span>
                        </td>
                        <td className="text-center">
                          {item.gold_quantity ? `${item.gold_quantity} gm` : "--"}
                        </td>
                        <td className="text-center">
                          {/* <Link to={`/transactions-details/${item.transaction_id}`}>₹ {item.price_per_gram || "--"}</Link> */}
                          {item.price_per_gram ? currenyFormat(item.price_per_gram) : "--"}
                        </td>
                        <td className="text-center">
                          {/* <Link to={`/transactions-details/${item.transaction_id}`}>₹ {item.total_amount || "--"}</Link> */}
                          {item.total_amount ? currenyFormat(item?.total_amount) : "--"}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className={`${Styles.no_hover}`}>
                      <td className={`fs-3 text-center`} colSpan={8}>
                        <NoDataFound width={500} />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Rewards;
